import { render, staticRenderFns } from "./makeSureText.vue?vue&type=template&id=c682d6ac&scoped=true"
import script from "./makeSureText.vue?vue&type=script&lang=js"
export * from "./makeSureText.vue?vue&type=script&lang=js"
import style0 from "./makeSureText.vue?vue&type=style&index=0&id=c682d6ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c682d6ac",
  null
  
)

export default component.exports